import { GetPaymentOptionsOpts, PaymentService } from '@/app/services/payments'
import { ErrorResponse, IApiIndividualResponse } from '@/types/api'
import { AllPaymentMethodConfigurations } from '@/types/payment'
import { useQuery, UseQueryOptions } from 'react-query'

export function usePaymentOptions(
  args: GetPaymentOptionsOpts,
  opts: Omit<
    UseQueryOptions<
      IApiIndividualResponse<AllPaymentMethodConfigurations[]>,
      ErrorResponse
    >,
    'queryKey' | 'queryFn'
  >
) {
  return useQuery<
    IApiIndividualResponse<AllPaymentMethodConfigurations[]>,
    ErrorResponse
  >(getPaymentOptionsQueryOptions(args, opts))
}

export function getPaymentOptionsQueryOptions(
  args: GetPaymentOptionsOpts,
  opts: Omit<
    UseQueryOptions<
      IApiIndividualResponse<AllPaymentMethodConfigurations[]>,
      ErrorResponse
    >,
    'queryKey' | 'queryFn'
  >
): UseQueryOptions<
  IApiIndividualResponse<AllPaymentMethodConfigurations[]>,
  ErrorResponse
> {
  return {
    queryKey: [PaymentService.GET_PAYMENT_OPTIONS_PATH, args],
    queryFn: () => PaymentService.getPaymentOptions(args),
    ...opts,
  }
}
